import { RouteRecordRaw } from "vue-router"
import { exampleRoutes } from "./example"
import { purchaseRoutes } from "./purchase"
import { userRoutes } from "./user"
import { layoutRoutes } from "./layout"
import { learningRoutes } from "./learning"
import { checkRoutes } from "./check"
import { mineRoutes } from "./mine"
import { recordRoutes } from "./record"

export const routes: RouteRecordRaw[] = [
	{
		path: "/",
		redirect: "/initApp",
	},
	{
		path: "/initApp",
		component: () => import("@/views/initApp/index.vue"),
		children: []
	},
	{
		path: "/",
		children: [...exampleRoutes, ...purchaseRoutes, ...userRoutes, ...layoutRoutes, ...learningRoutes, ...checkRoutes, ...mineRoutes, ...recordRoutes]
	},
	// {
	// 	path: "/login",
	// 	component: () => import("@/views/login.vue")
	// }
]
